module.exports = __webpack_public_path__ + "img/logo_full.53230dd5.png";